import { IntegrationBase } from './base';

export class BetConstructIntegration extends IntegrationBase {

  public handleChangeGameInUrl() {
    // todo
  }

  public exitGame(exitUrl = '') {
    // TODO
    window.location.href = exitUrl;
  }

}
